import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { TICKETS_PAGE, ZONES_PAGE, FINALIZE_PAGE, EXERCISE_PAGE, PASS_PAGE, REALIZE_VOUCHER_PAGE } from "./routes";
import ZonesPage from "./components/ZonesPage";
import TicketsPage from "./components/TicketsPage";
import useAuth from "../utils/hooks/useAuth";
import FinalizePage from "./components/FinalizePage";
import ExercisePage from "./components/ExercisePage";
import PassPage from "./components/PassPage";
import RealizeVoucherPage from "./components/RealizeVoucherPage";

const MainApp: React.FC = () => {
  useAuth();
  return (
    <BrowserRouter>
      <Routes>
        <Route path={ZONES_PAGE} element={<ZonesPage />} caseSensitive />
        <Route path={TICKETS_PAGE} element={<TicketsPage />} />
        <Route path={EXERCISE_PAGE} element={<ExercisePage />} />
        <Route path={FINALIZE_PAGE} element={<FinalizePage />} />
        <Route path={PASS_PAGE} element={<PassPage />} />
        <Route path={REALIZE_VOUCHER_PAGE} element={<RealizeVoucherPage />} />
      </Routes>
    </BrowserRouter>
  );
};

export default MainApp;
